<p-dialog [(visible)]="visible"
          [modal]="true"
          [draggable]="false"
          [resizable]="false"
          [header]="'Provide Access to Xpress'"
          (onHide)="onDialogHide()"
          [style]="{width: '600px'}">
    <div class="partner-provide-access-body">
        <div>By providing access to an Xpress Support member they can help you troubleshoot any issues you may face.</div>

        <div style="margin-top: 20px;">Whilst a remote session is in place, do not leave your computer so you can monitor and actions being taken.</div>

        <div style="margin-top: 20px;">At any time you can cancel the session so Xpress no longer has access to your Partner HQ. Alternatively, the session will automatically cease after 10mins.</div>

        <div style="margin-top: 20px;">By creating this session, you agree to the <a style="color: #4f8eec; cursor: pointer">Terms & Conditions</a></div>

        <div style="margin: 30px 0 30px 0; font-weight: 600">Session Code: XXXXX</div>

        <div style="margin-bottom: 30px; text-align: center">
            <button pButton type="button" label="Cancel" class="p-button-danger"
                    (click)="onCancelClick()"></button>
        </div>
    </div>
    <ng-template pTemplate="footer"></ng-template>
</p-dialog>